import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 110">
      <g data-name="Layer 2">
        <path fill="none" d="M0 0h150v110H0z" data-name="Rectangle 15168" />
        <g data-name="Group 1414">
          <g data-name="Group 1408">
            <g
              fill="none"
              stroke="#424242"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              data-name="Group 1401"
            >
              <path
                d="M79.69 58.73h17.64a7.44 7.44 0 005.29-2.19h0a7 7 0 00-7-7H58.29a3.46 3.46 0 01-3.24-2.24l-2.44-4.48a3.65 3.65 0 00-3.21-1.91h-2v11.44a6.38 6.38 0 006.38 6.38h13.74"
                data-name="Path 1179"
              />
              <path d="M68.69 56.09l-7.08 19.23h7.08l11.77-19.23" data-name="Path 1180" />
              <path d="M69.26 49.54l-5.47-14.86h7.08L80 49.54" data-name="Path 1181" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
